import styled from "styled-components";

const CustomContainer = styled.div`
  margin:0;
`;

export default CustomContainer;
